import React from 'react'
import { IBankHoliday } from '@cbgms/api'
import { TextField } from '@carsys/form/src/TextField'
import { Dropdown } from '@carsys/form/src/Dropdown'
import { DatePicker } from '@carsys/form/src/DatePicker'
import { useTranslation } from 'react-i18next'
import { isRequired, requiredDate } from '@cbgms/base/utils/validations'
import FormikFormLayout, { IDeleteOptions } from 'core/page/layout/FormikFormLayout'
import { Form, FormProps } from '@carsys/form'
import Box from '@mui/material/Box'
import { IDropdownOption } from '@carsys/ui/src/Dropdown'
import { Typography } from '@mui/material'

interface Props extends FormProps<IBankHoliday, IBankHoliday> {
  form: string
  headerText: string
  regionTags: IDropdownOption[]
  deleteOptions?: IDeleteOptions
}

const HolidayForm: React.FC<Props> = props => {
  const { regionTags, headerText, deleteOptions, form } = props
  const { t } = useTranslation()

  return (
    <Form formID={form} {...props}>
      <FormikFormLayout
        title={<Typography variant='h5'>{t(headerText)}</Typography>}
        backButtonProps={{ to: '/bank-holidays' }}
        deleteOptions={deleteOptions}
      >
        <Box
          sx={{
            display: 'flex',
            gap: 1,
            flexWrap: 'wrap',
            '&>*': { flex: '1 1 auto' }
          }}
        >
          <TextField
            fullWidth={false}
            data-testid='input-holiday-name'
            label={t('bank_holidays.name')}
            name='Name'
            required
            validate={isRequired}
          />
          <Dropdown
            fullWidth={false}
            data-testid='input-holiday-region'
            label={t('region_tag.title')}
            name='RegionTagUUID'
            options={regionTags}
            required
            validate={isRequired}
          />
          <DatePicker
            sx={{ width: 'auto', minWidth: '200px' }}
            data-testid='input-holiday-date'
            label={t('bank_holidays.date')}
            name='Date'
            required
            validate={v => {
              const d = requiredDate(v)
              const req = isRequired(v)
              return d || req
            }}
          />
        </Box>
      </FormikFormLayout>
    </Form>
  )
}

HolidayForm.displayName = 'HolidayForm'

export default HolidayForm
